import { Box, Tab, Tabs } from "@mui/material";
import { FC, useMemo, useState } from "react";
import PageContainer from "src/pages/components/PageContainer";
import { getUserCompanyId, isUserAdministrator, isUserCompany } from "src/utils/auth";
import CompanyBlockStatusTab from "./components/CompanyBlockStatusTab";
import TrainingChecklistPreview from "./components/TrainingChecklistPreview";

const MyCompany: FC = () => {
  const [tab, setTab] = useState<"checklist" | "status">("checklist");
  const companyId = getUserCompanyId();
  const isCompanyUser = useMemo(() => isUserCompany() && !isUserAdministrator(), []);

  return (
    <PageContainer title="Minha empresa" guard={() => isCompanyUser}>
      <Tabs
        value={tab}
        onChange={(_, newValue) => setTab(newValue)}
        variant="scrollable"
        scrollButtons="auto"
      >
        <Tab label="Treinamentos" value="checklist" />
        <Tab label="Status com a EezyCare" value="status" />
      </Tabs>

      {tab === "checklist" && (
        <Box display="flex" flexDirection="column" gap={4}>
          <TrainingChecklistPreview companyId={companyId ?? ''} />
        </Box>
      )}

      {tab === "status" && <CompanyBlockStatusTab />}
    </PageContainer>
  );
};

export default MyCompany;
